import React from 'react';
import { Link } from 'react-router-dom';


const Header = () => {
    return (
        <button className="btn btn-warning"><Link to="/">Home</Link> </button>
        
                
        
    );
};

export default Header;